export enum FormValidation {
  // Common
  Required = 'required',

  // Boolean`
  IsTrue = 'isTrue',

  // Number
  MinValue = 'minValue',
  MaxValue = 'maxValue',

  // String
  Email = 'email',
  Password = 'password',
  Url = 'url',
  MinLength = 'minLength',
  MaxLength = 'maxLength',
  Regex = 'regex',

  // Related
  Match = 'match',

  // Custom
  Sync = 'sync',
  Async = 'async',
}
